// This enum is supposed to be synchronized with the backend definition
export const TASK_TYPES = {
  TASK: 1,
  TIME_OFF: 2
}

export const STRIPED_TASK_STYLE = "striped";
export const MIXED_TASK_STYLE = "mixed";
export const MIXED_TASK_COLOR = "mixed";
export const DEFAULT_THEME = "3";
export const eventStyles = [
  "plain",
  "border",
  "hollow",
  "colored",
  "line",
  "dashed",
  "minimal",
  "rounded",
]